
import { useMutation } from "@tanstack/react-query";
import { FunctionalGraphItem } from "./use-get-functional-graph-service";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export async function saveFunctionalNode(payload: {
  label: string;
  data: Omit<FunctionalGraphItem, "id">;
}, uuid: string, token: string): Promise<FunctionalGraphItem & { label: string }> {
  const url = `${config.isometricApiUrl}/functional-graph/${uuid}/create-node`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json(); // Parse the JSON response
    return { ...data, label: payload.label };
  } catch (error) {
    console.error("Error:", error); // Handle errors
    throw error;
  }
}

export async function mergeFunctionalNodes(payload: {
  label: string;
  mergeIds: string[];
  targetId: string;
}, uuid: string, token: string): Promise<FunctionalGraphItem & { label: string }> {
  const url = `${config.isometricApiUrl}/functional-graph/${uuid}/merge-nodes`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return { ...data, label: payload.label };
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}

export const useCreateFunctionalNode = (onSettled?: (res: FunctionalGraphItem & { label: string } | undefined, error: Error | null) => void) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
                  body: {
                    label: string;
                    data: Omit<FunctionalGraphItem, "id">;
                  },
                  uuid: string
                }) => {
            const headers = getAuthHeaders();
                  const token = headers.Authorization.replace('Bearer ', '');
                  return saveFunctionalNode(payload.body, payload.uuid, token);
            },
      
      onSettled
  });
};

export const useMergeFunctionalNodes = (onSettled?: (res: FunctionalGraphItem & { label: string } | undefined, error: Error | null) => void) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
                  body: {
                    label: string;
                    mergeIds: string[];
                    targetId: string;
                  },
                  uuid: string
                }) => {
            const headers = getAuthHeaders();
            const token = headers.Authorization.replace('Bearer ', '');
            return mergeFunctionalNodes(payload.body, payload.uuid, token);
            },
      
      onSettled
  });
};
